import {useDocumentTitle} from '@mantine/hooks';

export default function useSetDocumentTitle(title: string) {
  useDocumentTitle(title);
}
